module.exports = __webpack_public_path__ + "img/25.problem_lightning.cbeef782.svg";